import request from "@/utils/interceptor.js";

const educationApi = {
  // 轮播图列表
  getBannerList(params) {
    return request({ url: `/api/pas/slideshow`, method: "get", params });
  },
  // 新增轮播图图片
  addBanner(data) {
    return request({ url: `/api/pas/slideshow`, method: "post", data });
  },
  // 删除轮播图图片
  deleteBanner(id) {
    return request({ url: `/api/pas/slideshow/${id}`, method: "delete" });
  },
  // 编辑轮播图图片
  editBanner(data) {
    return request({
      url: `/api/pas/slideshow/${data.id}`,
      method: "put",
      data,
    });
  },
};

export default educationApi;
